<template>
    <div class="quiz__campaign__endpoint-primary-product">
        <div class="quiz__campaign__endpoint-primary-product-text top">
            <h2 class="quiz__campaign__endpoint-primary-product-name">{{ product.name }}</h2>
        </div>
        <div v-if="product.featured_image" class="quiz__campaign__endpoint-primary-product-image">
            <img :src="product.featured_image.image_urls.large" :alt="product.featured_image.alt_text" />
        </div>
        <div class="quiz__campaign__endpoint-primary-product-text side" :class="{ 'no-image' : product.featured_image == null }">
            <h2 class="quiz__campaign__endpoint-primary-product-name">{{ product.name }}</h2>
            <p class="quiz__campaign__endpoint-primary-product-sku">{{ product.model }}</p>
            <review-block v-if="showReviews" :rating="product.reviews_rating"></review-block>
            <p class="quiz__campaign__endpoint-primary-product-price">&pound;{{ product.display_price }}</p>
            <div class="quiz__campaign__endpoint-primary-product-description" v-html="product_text" @click="updateProductText"></div>
            <div class="quiz__campaign__endpoint-product-actions">
                <a :href="product.links.view" class="quiz__campaign__endpoint-button">View</a>
                <a  :href="product.links.buy" class="quiz__campaign__endpoint-button quiz__campaign__endpoint-button-primary basket-add" v-if="showBuy && product.links.buy !== null">Buy</a>
            </div>
        </div>
    </div>
</template>
<script>

import ReviewBlock from './reviews-block';

export default {
    props: ['product','shopconfig','product_content','with_link'],
    components: {
        ReviewBlock
    },
    computed: {
        showBuy: function() {
            return (this.shopconfig.ecommerce.enabled == 1) ? true : false;
        },
        showReviews: function() {
            return (this.shopconfig.bazaarvoice.enabled == 1) ? true : false;
        }
    },
    mounted() {
        this.product_text = (this.with_link.length > 0) ? this.with_link : this.product_content;
    },
    methods: {
        updateProductText()
        {
            this.product_text = this.product_content.replace('[readmorelink]','');
        },
        config( setting ){
            return false;
        }
    },
    data() {
        return {
            product_text: ''
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/content-blocks/primary-product.vue